/**
 * @file Does a decimal-safe arithmetic operation on two amounts.
 */
import Big from "big.js";

type DecimalValue = number | string;

type Operand = "plus" | "minus" | "times" | "div";

/**
 * Applies the given arithmetic operand to two decimal amounts without floating-point rounding errors.
 */
const getFormattedDecimalValue = (
  firstValue: DecimalValue,
  secondValue: DecimalValue,
  operand: Operand,
): number => {
  const big = new Big(firstValue)[operand](secondValue);
  const amount = big.toNumber();

  return amount;
};

export default getFormattedDecimalValue;
